var map = {
	"./__variants__/plp-unlabelled-images/OriginalPrice/index.js": 39,
	"./__variants__/plp-unlabelled-images/ProductDeal/index.js": 4724,
	"./__variants__/plp-unlabelled-images/ProductPrice/index.js": 5466,
	"./__variants__/plp-unlabelled-images/v2/index.js": 7513,
	"./__variants__/plp-unlabelled-images/v3/index.js": 6466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5907;